import { useContext } from 'react';
import { useMemo } from 'react';
import { PayBenchmarkingContext } from 'apps/sigma2-ui/src/pay-benchmarking/components/PayBenchmarkingContext';
import { PayBenchmarkingHook } from 'apps/sigma2-ui/src/pay-benchmarking/hooks/PayBenchmarkingHook';

export const usePayBenchmarking = (): PayBenchmarkingHook => {
  const context = useContext(PayBenchmarkingContext);

  const {
    selectableBenchmarks,
    selectedBenchmark,
    setSelectedBenchmark,
    selectableDepartments,
    selectedDepartment,
    setSelectedDepartment,
    selectableRoles,
    selectedRole,
    setSelectedRole,
    selectableLevels,
    selectedLevel,
    setSelectedLevel,
    selectableLocations,
    selectedLocation,
    setSelectedLocation,
    selectedExperience,
    setSelectedExperience,
    selectableEducationLabels,
    selectedEducationLabel,
    setSelectedEducationLabel,
    selectableCurrencies,
    selectedCurrency,
    setSelectedCurrency,
    selectableCompensationUnits,
    selectedCompensationUnit,
    setSelectedCompensationUnit,
    canApplyFilters,
    onApplyFilters,
    currentState,
    generateShareLink,
    onUserAnalysisCancel,
  } = context;

  return useMemo(() => {
    return {
      selectableBenchmarks,
      selectedBenchmark,
      setSelectedBenchmark,
      selectableDepartments,
      selectedDepartment,
      setSelectedDepartment,
      selectableRoles,
      selectedRole,
      setSelectedRole,
      selectableLevels,
      selectedLevel,
      setSelectedLevel,
      selectableLocations,
      selectedLocation,
      setSelectedLocation,
      selectedExperience,
      setSelectedExperience,
      selectableEducationLabels,
      selectedEducationLabel,
      setSelectedEducationLabel,
      selectableCurrencies,
      selectedCurrency,
      setSelectedCurrency,
      selectableCompensationUnits,
      selectedCompensationUnit,
      setSelectedCompensationUnit,
      canApplyFilters,
      onApplyFilters,
      currentState,
      generateShareLink,
      onUserAnalysisCancel,
    };
  }, [
    canApplyFilters,
    currentState,
    generateShareLink,
    onApplyFilters,
    selectableBenchmarks,
    selectableCompensationUnits,
    selectableCurrencies,
    selectableDepartments,
    selectableEducationLabels,
    selectableLevels,
    selectableLocations,
    selectableRoles,
    selectedBenchmark,
    selectedCompensationUnit,
    selectedCurrency,
    selectedDepartment,
    selectedEducationLabel,
    selectedExperience,
    selectedLevel,
    selectedLocation,
    selectedRole,
    setSelectedBenchmark,
    setSelectedCompensationUnit,
    setSelectedCurrency,
    setSelectedDepartment,
    setSelectedEducationLabel,
    setSelectedExperience,
    setSelectedLevel,
    setSelectedLocation,
    setSelectedRole,
    onUserAnalysisCancel,
  ]);
};
